import { useCallback } from "react";

import { RpSweetAlert } from "@/components/alerts/RpSweetAlert";
import { ENV } from "@/config/env";
import { getLocal } from "@/helpers/localStore";
import { LOCAL_STORAGE } from "@/config/constants";

const SOCIAL_POSTING_BASE_URL = ENV.SOCIAL_POSTING_BASE_URL;

interface UseSocialPostingsParams {
  closeSidebar?: () => void;
  brandId?: number | string | null;
}

function useSocialPostings({
  closeSidebar,
  brandId,
}: UseSocialPostingsParams = {}) {
  const navigateToSocialPostings = useCallback(() => {
    closeSidebar?.();

    const token = getLocal(LOCAL_STORAGE.TOKEN_NAME);
    if (!token || typeof token !== "string") {
      RpSweetAlert.fire({
        icon: "error",
        title: "Error",
        text: "Unable to access Social Posting. Please try again.",
        confirmButtonText: "OK",
        showCancelButton: false,
      });
      return;
    }

    const searchParams = new URLSearchParams({ token });
    if (brandId !== undefined && brandId !== null && brandId !== "") {
      searchParams.set("brand_id", String(brandId));
    }

    const socialPostingUrl = `${SOCIAL_POSTING_BASE_URL}/sso-login?${searchParams.toString()}`;

    window.open(socialPostingUrl, "_self", "noopener,noreferrer");
  }, [brandId, closeSidebar]);

  return { navigateToSocialPostings };
}

export default useSocialPostings;
